import { useCallback, useEffect, useState } from "react";
import {
  getLegacySessionInfo,
  getSessionInfo as getSessionInfoRequest
} from "./requests";
import { mapSessionInfoResponse } from "./mappers";
import { getCookie, setCookie } from "services/cookies";
import { clearAuthCookies, setUserToken } from "services/auth";
import { COOKIES } from "constants/cookies";

export const useSessionInfo = (initialState) => {
  const [sessionInfo, setSessionInfo] = useState(initialState);

  const getSessionInfo = useCallback(async (newToken) => {
    try {
      // get 'token' cookie if user was logged in on legacy pages
      const response = await getLegacySessionInfo();

      // clear all auth cookies if the current user was not logged in on legacy 'session_info' request
      if (!response.logged_in) {
        clearAuthCookies();
      }
    } catch {
      // do nothing
    } finally {
      const response = await getSessionInfoRequest();
      const formattedResponse = mapSessionInfoResponse(response);
      if (newToken) {
        setUserToken({ token: newToken });
      }

      setSessionInfo({ ...formattedResponse, isInitialLoading: false });
    }
  }, []);

  useEffect(() => {
    // set userUUID on cookies when necessary
    const hasUserUUIDCookie = !!getCookie(COOKIES.USER_UUID);
    if (hasUserUUIDCookie || !sessionInfo?.userID) return;

    setCookie({
      name: COOKIES.USER_UUID,
      value: sessionInfo?.userID,
      days: 28
    });
  }, [sessionInfo?.userID]);

  return {
    sessionInfo,
    getSessionInfo
  };
};
